import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import ButtonToggle from '../../ButtonToggle/index'
import { getBoundActions } from '../../../actions/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { PLAYER_INFO_TOGGLED_GA4_EVENT } from '../../../services/event-tracking/index'

const VideoPlayerInfo = (props) => {
  const {
    videoPlayerInfoDisabled,
    staticText,
    setFeatureTrackingDataPersistent,
  } = props

  const title = 'videoPlayerInfo'
  const description = 'videoPlayerInfoDesc'
  const onVideoPlayerInfoChange = () => {
    setFeatureTrackingDataPersistent({
      data: Map({ disableVideoInfo: !videoPlayerInfoDisabled }),
    })
  }

  const ga4EventData = PLAYER_INFO_TOGGLED_GA4_EVENT.mergeDeep({
    changed_to: videoPlayerInfoDisabled ? 'on' : 'off',
    ui_location: 'Settings',
  })

  return (
    <div className="my-account-settings-V2__display-settings-controls">
      <div className="my-account-settings-V2__display-settings-text-container">
        <div className="my-account-settings-V2__display-settings-title">
          {staticText.getIn(['data', title])}
        </div>
        <div className="my-account-settings-V2__display-settings-text">
          {staticText.getIn(['data', description])}
        </div>
      </div>
      <div className="my-account-settings-V2__display-settings-toggle">
        <ButtonToggle
          checked={!videoPlayerInfoDisabled}
          onChange={onVideoPlayerInfoChange}
          showLabel
          ga4EventData={ga4EventData}
          round
        />
      </div>
    </div>
  )
}

VideoPlayerInfo.propTypes = {
  videoPlayerInfoDisabled: PropTypes.bool.isRequired,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => {
      return {
        videoPlayerInfoDisabled: state.featureTracking.getIn(
          ['data', 'disableVideoInfo'],
          false,
        ),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent:
          actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
  connectStaticText({ storeKey: 'myAccountSettingsV2' }),
)(VideoPlayerInfo)
